<template>
  <div class="tableauDeBord">
    <BasicIcon
      name="tableauDeBord"
      class="tableauDeBord--background"
    />
    <div class="tableauDeBord--label">
      <BasicText
        size="h5"
        color="white"
      >
        Tableau de bord
      </BasicText>
    </div>
    <div
      class="document-card--container hide-scrollbar"
      ref="containerRef"
      @scroll="onScroll"
    >
      <DocumentCard
        v-for="(card, docKey, i) in documentCards"
        :key="docKey"
        :id="makeId(i)"
        :type="docKey"
        :permissions="card.permissions"
        :indicateurs="card.indicateurs"
        @ajout-document="ajoutDocument(docKey)"
        @redirection-document="redirectionDocument(docKey, $event)"
        @retry-fetch="fetchIndicator(docKey, $event)"
      />
    </div>
    <div
      class="dots"
      v-if="showDots"
    >
      <a
        v-for="(_card, type, i) in documentCards"
        :key="i"
        :class="['dot', `dot--${type}`, { active: i === currentIndex }]"
        @click="scrollToIndex(i)"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { storeToRefs } from 'pinia'
  import { useIndicateurTdbStore } from './useIndicateurTdbStore'
  import DocumentCard from './documentCard/DocumentCard.vue'
  import { useIndicateurTdbScroll } from './useIndicateurTdbScroll'

  const store = useIndicateurTdbStore()
  const { documentCards } = storeToRefs(store)
  const { ajoutDocument, redirectionDocument, fetchIndicator } = store

  const { containerRef, currentIndex, showDots, onScroll, scrollToIndex, makeId } = useIndicateurTdbScroll()
</script>

<style scoped lang="less">
  @import './IndicateurTdb.less';
</style>
